import axiosInstance from "../axiosConfig";

export const login = async (email, password) => {
  try {
    const response = await axiosInstance.post("/auth/login", {
      email,
      password,
    });
    // B4 (Phase 42): backend returns { requires2fa, challengeToken }
    // when 2FA is enabled — caller must complete via twoFactorChallenge().
    if (response.data.requires2fa) {
      return response.data;
    }
    if (response.data.token) {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// B4 — second step of 2FA login: exchange challengeToken + code for the
// real session JWT.
export const twoFactorChallenge = async (challengeToken, code) => {
  try {
    const response = await axiosInstance.post("/auth/2fa/challenge", {
      challengeToken,
      code,
    });
    if (response.data.token) {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const register = async (userData) => {
  try {
    const response = await axiosInstance.post("/auth/register", userData);
    // Don't store token on registration - user needs to login separately
    return response.data;
  } catch (error) {
    console.error("Registration API error:", error);

    // Handle different error formats
    if (error.response) {
      // The server responded with a status code outside the 2xx range
      const errorData = error.response.data;
      console.log("Server error response:", errorData);

      if (errorData && typeof errorData === "object") {
        throw errorData;
      } else if (typeof errorData === "string") {
        throw { message: errorData };
      } else {
        throw { message: `Server error: ${error.response.status}` };
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.log("No response received:", error.request);
      throw {
        message: "No response from server. Please check your connection.",
      };
    } else {
      // Something happened in setting up the request
      console.log("Request setup error:", error.message);
      throw { message: error.message || "Error sending request" };
    }
  }
};

export const checkRegistrationStatus = async () => {
  try {
    const response = await axiosInstance.get("/auth/registration-status");
    return response.data.canRegister;
  } catch (error) {
    console.error("Error checking registration status:", error);
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem("user");
  if (!userStr) return null;
  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error("Error parsing user data:", error);
    return null;
  }
};

export const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

export const hasPermission = (permission) => {
  const user = getCurrentUser();
  if (!user) return false;

  if (user.isAdmin) return true;

  return user.permissions && user.permissions[permission];
};
